import { useOnboarding } from "./hooks/useOnboarding";
import {
  AcademicYearStep,
  GraduationClassStep,
  OrganizationStep,
  AddStudentsStep,
  CompleteStep,
} from "./steps";
import { OnboardingStepper } from "./components";
import { Organization } from "types/organization";
import { AcademicYear } from "types/academicYear";
import { GraduationClass } from "types/graduationClass";
import { useClinicText } from "hooks/useClinicText";
import { STEPS } from "./hooks/useOnboardingStepManager";

export const Onboarding = () => {
  const {
    state,
    organization,
    academicYearId,
    previousStep,
    nextStep,
    goToStep,
    programId,
    academicYear,
    graduationClass,
    graduationClassId,
    studentsAdded,
    setStudentsAdded,
    onYearlyCurriculumCreated,
    onGraduationClassCreated,
  } = useOnboarding();
  const { textGraduationClass, textYearlyCurriculum } = useClinicText(
    false,
    organization,
  );

  // Define the steps of the onboarding
  const steps = [
    {
      label: "Organization",
      component: (
        <OrganizationStep
          organization={organization as Organization}
          onNext={nextStep}
          onBack={state.currentStepIndex > 0 ? previousStep : undefined}
        />
      ),
      onClickStep: () => {
        goToStep(STEPS.ORGANIZATION);
      },
    },
    {
      label: textYearlyCurriculum,
      component: (
        <AcademicYearStep
          onAcademicYearCreated={(academicYearId) => {
            onYearlyCurriculumCreated(academicYearId);
          }}
          onNext={nextStep}
          onBack={previousStep}
          programId={programId}
          academicYear={academicYear as AcademicYear}
          organization={organization as Organization}
        />
      ),
      onClickStep: () => {
        goToStep(STEPS.ACADEMIC_YEAR);
      },
    },
    {
      label: textGraduationClass,
      component: (
        <GraduationClassStep
          organizationId={state.organizationId}
          academicYearId={academicYearId || undefined}
          onGraduationClassCreated={(graduationClassId) => {
            onGraduationClassCreated(graduationClassId);
          }}
          graduationClass={graduationClass as GraduationClass}
          programId={programId || undefined}
          onNext={nextStep}
          onBack={previousStep}
          organization={organization as Organization}
        />
      ),
      onClickStep: () => {
        goToStep(STEPS.GRADUATION_CLASS);
      },
    },
    {
      label: "Add Students",
      component: (
        <AddStudentsStep
          onNext={nextStep}
          onBack={previousStep}
          graduationClassId={graduationClassId || undefined}
          organization={organization as Organization}
          onGraduationClassStudentsAdded={(students) => {
            setStudentsAdded(students);
            console.log(`${students.length} students added successfully`);
          }}
        />
      ),
      onClickStep: () => {
        goToStep(STEPS.ADD_STUDENTS);
      },
    },
    {
      label: "Complete",
      component: (
        <CompleteStep
          organization={organization as Organization}
          academicYear={academicYear as AcademicYear}
          graduationClass={graduationClass as GraduationClass}
          studentsAdded={studentsAdded}
        />
      ),
    },
  ];

  return (
    <OnboardingStepper steps={steps} activeStep={state.currentStepIndex} />
  );
};
